import React, { useEffect, useState } from 'react';
import { PinPukHelpIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/help';
import Panel from '@womcorp/wom-miwom-ui-kit/dist/components/Panel';
import { PinPukIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';
import Button from '@womcorp/wom-miwom-ui-kit/dist/components/Button/Button';
import { InfoIconBlack } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import { ActionButtonStyled } from '../../styles/HelpStyled';
import CustomerService from '../../../../services/Customer';
import Loading from '../../../General/Loading';
import {
  ContainerStyled as Container,
  SimcardResourcesStyled as SimResources,
  SimcardResourcesWrapperStyled as SimResourcesWrapper,
  AdminInfoStyled as AdminInfo,
} from './styles/SimcardResourcesStyled';
import useUser from '../../../../hooks/useUser';
import { useGlobalData } from '../../../../contextProvider/GlobalDataContext';
import { GoogleTagManager } from '../../../../helpers';
import ErrorPanel from '../../../Errors/ErrorFormikPanel';

const SimcardResources = () => {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState(0);
  const [pinPuk, setPinPuk] = useState(null);
  const [loading, setLoading] = useState(true);
  const closePanel = () => setOpen(false);
  const {
    'contact-url-simcard-resources': { url = '' },
  } = useGlobalData();
  const {
    plan: { number },
    user: { isAdmin },
  } = useUser();
  const formattedNumber = `+${number}`.replace(/(.{4})/g, '$1 ').trim();

  const simcardResourcesData = () => {
    setLoading(true);
    CustomerService.suscriptorSimcard()
      .then(([{ data }]) => {
        setPinPuk(prev => ({ ...prev, ...data }));
      })
      .catch(({ status }) => {
        setErrors(status ?? 400);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (open) {
      GoogleTagManager.pushToDataLayer({
        event: 'pagina-virtual',
        page: '/ayuda/codigo-pin-puk',
        pagename: 'Ayuda - Modal Código Pin y Puk',
      });
    }
  }, [open]);

  const openPanel = () => {
    setOpen(true);
    simcardResourcesData();
  };

  const Content = (() => {
    if (loading) return <Loading />;

    if (errors) {
      return (
        <ErrorPanel
          title="Ha ocurrido un error"
          retry={() => simcardResourcesData()}
        >
          <span>
            No se ha podido completar tu solicitud, vuelve a intentarlo
          </span>
        </ErrorPanel>
      );
    }

    return (
      <Container>
        <PinPukIcon />
        <SimResourcesWrapper>
          <span>Tenemos la información de tu línea {formattedNumber}</span>
          <SimResources>
            {pinPuk?.pin1 && (
              <p>
                PIN 1: <b>{pinPuk?.pin1}</b>
              </p>
            )}
            {pinPuk?.pin2 && (
              <p>
                PIN 2: <b>{pinPuk?.pin2}</b>
              </p>
            )}
            {pinPuk?.puk1 && (
              <p>
                PUK 1: <b>{pinPuk?.puk1}</b>
              </p>
            )}
            {pinPuk?.puk2 && (
              <p>
                PUK 2: <b>{pinPuk?.puk2}</b>
              </p>
            )}
          </SimResources>
        </SimResourcesWrapper>
        <Button onClick={() => closePanel()}>Volver</Button>
        {isAdmin && (
          <AdminInfo>
            <aside>
              <InfoIconBlack />
            </aside>
            <span>
              Si necesitas validar la información de tus líneas adicionales{' '}
              <a href={url} target="_blank" rel="noopener noreferrer">
                contacta a un ejecutivo
              </a>
            </span>
          </AdminInfo>
        )}
      </Container>
    );
  })();

  return (
    <>
      <ActionButtonStyled
        icon={PinPukHelpIcon}
        onClick={openPanel}
        upperTitle="Mi código PIN - PUK"
      />
      <Panel open={open} title="Mi Código PIN - PUK" onClose={closePanel}>
        {Content}
      </Panel>
    </>
  );
};

export default SimcardResources;
